import { Fragment, type FC } from 'react';
import { Outlet } from 'react-router';

import { AppDrawer } from '#packages/web/navigation/app-drawer';

import { useAppConfig } from '#apps/client-web/app/config/app.browser';
import { useUserProfile } from '#apps/client-web/features/auth/hooks/use-user-profile';
import { useAuth } from '#apps/client-web/features/auth/hooks/use-auth';
import { useDrawer } from '#apps/client-web/app/hooks/use-drawer';
import { routes } from '#apps/client-web/app/routes';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';

export const AppLayout: FC = () => {
  const logger = useLogger('app/components/app-layout');

  const auth = useAuth({ logger });
  const userProfile = useUserProfile(auth.user);
  const drawer = useDrawer();

  const appConfig = useAppConfig();

  return (
    <Fragment>
      {/* RENDER ALWAYS AVAILABLE COMPONENTS HERE */}
      <AppDrawer
        open={drawer.isOpen}
        onClose={drawer.close}
        onSignInClick={auth.onSignIn}
        onSignOutClick={auth.onSignOut}
        userProfile={userProfile}
        routes={{
          auditsList: routes.audit.index,
          userProfile: routes.userProfile.index,
          userSettings: routes.appSettings.index,
        }}
        appVersion={appConfig.version}
      />

      {/* DO NOT ADD ANYTHING BELOW THIS LINE */}
      <Outlet />
    </Fragment>
  );
};
